var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('v-select', {
    staticClass: "changeProgressUpdateIndicator",
    staticStyle: {
      "width": "140px",
      "margin-bottom": "-26px"
    },
    attrs: {
      "loading": _vm.isProgressUpdating,
      "disabled": _vm.isProgressUpdateLoading,
      "items": _vm.items,
      "value": _vm.progress,
      "dense": "",
      "flat": "",
      "solo": ""
    },
    on: {
      "change": _vm.setProgress
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("partner.PartnerReportDetailChangeProgress.".concat(item))) + " ")];
      }
    }, {
      key: "selection",
      fn: function fn() {
        return [_c('small', [_vm._v(_vm._s(_vm.$t("partner.PartnerReportDetailChangeProgress.".concat(_vm.progress))))])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }